import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import { buildPageContextFields, buildImpressionFields } from 'ai/analytics/utils/sotFields';
import { EVENT_NAMES } from 'ai/analytics/events';

export const IMPRESSION_DELAY_THRESHOLD = 1000;

export const VISIBILITY_THRESHOLD = 0.5;

export function trackViewableImpression({ prompts = [], sotFields = {} }) {
    const eventName = EVENT_NAMES.VIEWABLE_IMPRESSION;
    const impressionFields = buildImpressionFields(prompts, IMPRESSION_DELAY_THRESHOLD);

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...impressionFields,
            ...sotFields
        }
    });
}

export function buildImpressionSotFields(pageContext = {}) {
    return buildPageContextFields(pageContext);
}
